var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.495,
    viewBox: "0 0 20 17.495",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4517",
    "data-name": "Path 4517",
    d: "M1.255,8.123C1.255,4.554,4.918,1.25,10,1.25s8.748,3.3,8.748,6.873S15.088,15,10,15a11.342,11.342,0,0,1-3.651-.633,1.273,1.273,0,0,0-1.14.164,11.029,11.029,0,0,1-1.89,1.07l.246.57-.25-.574a8.533,8.533,0,0,1-1.277.449c.02-.035.043-.07.062-.1a7.3,7.3,0,0,0,1-2.98,1.23,1.23,0,0,0-.289-.933A6.083,6.083,0,0,1,1.255,8.123M10,0c-5.526,0-10,3.64-10,8.123a7.333,7.333,0,0,0,1.851,4.706s0,0,0,.008A6.038,6.038,0,0,1,1.029,15.3a5.869,5.869,0,0,1-.847,1.133A.623.623,0,0,0,.626,17.5a8.249,8.249,0,0,0,3.187-.754,12.087,12.087,0,0,0,2.1-1.191.034.034,0,0,1,.027,0,12.689,12.689,0,0,0,4.058.7c5.526,0,10-3.64,10-8.123S15.529,0,10,0M5,9.06a.937.937,0,1,0-.937-.937A.937.937,0,0,0,5,9.06m5,0a.937.937,0,1,0-.937-.937A.937.937,0,0,0,10,9.06m5.936-.937A.937.937,0,1,0,15,9.06a.937.937,0,0,0,.937-.937",
    transform: "translate(0)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chat.5311e1c35009a955422dfae5d47ce492.svg";